export default __webpack_public_path__ + "static/media/barcode2.18f55968.svg";